import { message } from 'ant-design-vue'
import {
  activityTag_deleteTag_post,
  activityTag_queryTagDetail_post,
  activityTag_queryTagList_post,
  activityTag_upsertTag_post,
  activityTag_modifyTagPosition_post
} from 'server/modules/4228'
// 删除标签
export const activityTag_deleteTag_post_ = async function(params, cb) {
  const { success, retInfo } = await activityTag_deleteTag_post(params)
  if (success) {
    message.success(retInfo)
    cb()
  } else {
    message.error(retInfo)
  }
}

// 查询标签详情
export const activityTag_queryTagDetail_post_ = async function(params) {
  const { tagId } = params.postParams
  const { success, data, retInfo } = await activityTag_queryTagDetail_post({
    tagId
  })
  if (success) {
    params.postParams = data
  } else {
    message.error(retInfo)
  }
}

// 查询标签列表
export const activityTag_queryTagList_post_ = async function(params) {
  const { searchParams } = params
  const { success, data, retInfo } = await activityTag_queryTagList_post({
    ...searchParams
  })
  if (success) {
    params.dataSource = data
  } else {
    message.error(retInfo)
    return
  }
}

// 新增/编辑标签
export const activityTag_upsertTag_post_ = async function(
  params,
  searchParams,
  jumpPage
) {
  const {
    jumpUrl,
    tagName,
    showWord,
    mark,
    tagType,
    mobileIconUrl,
    pcIconUrl
  } = params

  if (!tagName || tagName === null || tagName === '') {
    message.warning('标签名称不能为空！')
    return
  }

  if (
    !showWord ||
    showWord === null ||
    showWord === '' ||
    showWord === undefined
  ) {
    message.warning('展示文案不能为空！')
    return
  }
  if (
    (!jumpUrl || jumpUrl === null || jumpUrl === '') &&
    (tagType === 1 || tagType === 3)
  ) {
    message.warning('URL不能为空！')
    return
  }
  if (
    tagType === 2 &&
    (!mobileIconUrl ||
      mobileIconUrl === null ||
      mobileIconUrl === '' ||
      !pcIconUrl ||
      pcIconUrl === null ||
      pcIconUrl === '')
  ) {
    message.warning('活动ICON不能为空！')
    return
  }
  if (!mark || mark === null || mark === '') {
    message.warning('备注不能为空！')
    return
  }
  const { success, retInfo } = await activityTag_upsertTag_post({
    ...params,
    ...searchParams
  })
  if (success) {
    message.success(retInfo)
    jumpPage('TagManage')
  } else {
    message.error(retInfo)
  }
  params = {
    jumpUrl: null, // 图标
    mark: null,
    mobileIconUrl: null,
    pcIconUrl: null,
    showWord: null,
    status: 0, // 状态 0禁用 1启用
    tagId: null,
    tagName: null,
    tagType: 1, //标签类型 1活动标签（文案）2活动标签（ICON）3下单标签
    brandId: null, // 品牌ID
    channelId: null, // 渠道ID
    terminalId: null // 终端ID
  }
}

// 调整标签顺序
export const activityTag_modifyTagPosition_post_ = async function(
  sortList,
  cb
) {
  const { success, retInfo } = await activityTag_modifyTagPosition_post({
    sortList
  })
  if (success) {
    message.success(retInfo)
    cb()
  } else {
    message.error(retInfo)
  }
}
